import { defineComponent as _defineComponent } from 'vue'
import { LibAppType, LibLoginType } from '@/consts'
import _ from 'lodash'
import { reactive } from 'vue'
import Edit from './edit.vue'
import { store } from './store'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const include = _.includes

const state = reactive(store)
state.list.fetch()

const { list, edit } = state

return { __sfc: true,include, state, list, edit, LibAppType, LibLoginType, Edit }
}

})